/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import {createElement} from '@wordpress/element';
import {FireworkVideosEmbedFeed, FireworkVideosStoryblock} from "./firework-video";


/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save(props){
  var el = createElement;
  let attributes = props.attributes;
  console.log('save:');
  console.log(props.attributes);
  if(typeof attributes.entity === "undefined" || attributes.entity === ""){
    console.log("entity is empty");
  }else{
    if(attributes.layout === "storyblock"){
      if(attributes.channelUsername){
        return <FireworkVideosStoryblock channelUsername={attributes.channelUsername} videoId={attributes.videoId} maxVideosValue={attributes.maxVideosValue} autoplay={attributes.autoplay} onlyShowVideosSelected={attributes.onlyShowVideosSelected} />
      }
    }else{
      if(attributes.mode && attributes.openMethodValue && attributes.channelUsername){
        return <FireworkVideosEmbedFeed playlistId={attributes.playlistId} channelUsername={attributes.channelUsername} mode={attributes.mode} openIn={attributes.openMethodValue} maxVideosValue={attributes.maxVideosValue} autoplay={attributes.autoplay} />
      }
    }
  }

  return el('div')
}
